<template>
  <div class="assessment px-4">
    <img src="@/assets/preview/assessment_card.jpg" height="200" alt="B2BAssessmentCard" class="mb-4" />
    <img src="@/assets/preview/assessment_landing.jpeg" height="200" alt="B2BAssessmentLanding" class="mb-4" />
    <img src="@/assets/preview/assessment_result.jpeg" height="200" alt="B2BAssessmentResult" class="mb-4" />
    <b2b-assessment-table :assessments="assessments" @onFetch="fetchB2BAssessment" />
  </div>
</template>

<script>
import { Vue } from 'vue-property-decorator';
import store from '../../../store';
import B2BAssessmentService from '../../../services/b2bassessment';
import B2bAssessmentTable from './B2bAssessmentTable.vue';

export default Vue.extend({
  store,
  components: {
    B2bAssessmentTable,
  },
  data: () => ({
    language: 'both',
    assessments: [],
  }),
  mounted() {
    this.fetchB2BAssessment();
  },
  methods: {
    fetchB2BAssessment() {
      B2BAssessmentService.fetchB2BAssessment(this.language).then((assessments) => {
        this.assessments = assessments;
      });
    },
    deleteSection(id) {
      this.$root.$confirm('delete section', `This change will take effect on app immediately.`, id, {
        color: 'primary',
      });
    },
  },
});
</script>

<style lang="css" scoped></style>
